// Авторский текст обратной связи квиза для показа рядом с вердиктом. Плеер
// берёт его теми же полями (`QuizBlock` → `BlockAnswerFooter.feedback`);
// у сопоставления и опроса таких полей в контракте нет вовсе.
import type { QuizBlock } from '@/types/blocks'
import type { ContentLang } from '@/features/editor/editorSlice'
import { getLocalizedDisplay } from '@/features/editor/lib/localizedField'
import type { Verdict } from '../../preview/verdict'
import { verdictGrade } from '../../preview/verdictView'

export const quizFeedback = (
  block: QuizBlock,
  contentLang: ContentLang,
  verdict: Verdict | null,
): string => {
  // Разбор вердикта общий: без него новый его вариант молча уехал бы в текст
  // «неправильного» ответа.
  const grade = verdictGrade(verdict)
  if (grade === 'ungraded') return ''
  const base = grade === 'correct' ? 'correctFeedback' : 'incorrectFeedback'
  return getLocalizedDisplay(block, base, contentLang, false)
}
